'use strict';

const photoSize = {
  w: 120,
  h: 120
};

/**
 * Model that represents current logged in user
 */
export default class UserModel {
  constructor($q, $rootScope, $window, userResource, analytics, imgixHelpers) {
    'ngInject';

    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$window = $window;
    // this.raven = $raven;
    this.resource = userResource;
    this.analytics = analytics;
    this.imgixHelpers = imgixHelpers;

    this.item = {};
    this.itemPromise = this.$q.resolve();
  }

  initItem(id, no_event) {
    this.itemPromise = new this.$q((resolve, reject) => {
      if (id) {
        this.item = {
          id: id
        };
        this.resource.findById(id)
          .then((user) => {
            this.item = user;
            const traits = {
              name: user.name
            };
            const profilePhoto = user.profilePhoto;

            if (profilePhoto) {
              const crop = this.imgixHelpers.getCropCoords(profilePhoto.crop);
              const photoUrl = this.imgixHelpers.getUrl(profilePhoto, photoSize, crop);
              traits.avatar = `https:${photoUrl}`;
            }

            this.analytics.identify(user.id, traits);

            // this.raven.setUserContext({id: user.id});

            if (!no_event) {
              this.$rootScope.$emit('userModel:initialized');
            }
            resolve(this.item);
          })
          .catch(reject);
      } else {
        resolve(this.item);
      }
    });

    return this.itemPromise;
  }

  hasMembership() {
    const membership = this.item.membership || {};

    return membership.expires && (new Date(membership.expires * 1000) > new Date());
  }

  getCurrency() {
    const preferences = this.item.preferences || {};

    return preferences.currency;
  }

  hasMessenger() {
    return this.item.preferences && this.item.preferences.fbMessengerId;
  }

  getLoginHistory(){
    this.loginHistory = new this.$q((resolve, reject) => {
      this.resource.getLoginHisotry(this.item.id)
        .then((history) => {
          resolve(history);
        })
        .catch(reject);
    });
    return this.loginHistory;
  }

  copyData(){
    this.copy = new this.$q((resolve, reject) => {
      this.resource.copyData(this.item.id)
        .then((data) => {
          resolve(data);
        })
        .catch(reject);
    });
    return this.copy;
  }

  getBraintreeToken() {
    if ('braintreeToken' in this) {
      return this.braintreeToken;
    }

    this.braintreeToken = new this.$q((resolve, reject) => {
      this.resource.getBraintreeToken(this.item.id)
          .then((data) => {
            resolve(data);
          })
          .catch(reject);
    });

    return this.braintreeToken;
  }

  processBraintreePayment(data) {
    var res = new this.$q((resolve, reject) => {
      this.resource.processBraintreePayment(this.item.id, data)
          .then((data) => {
            resolve(data);
          })
          .catch(reject);
    });

    return res;
  }



}



// WEBPACK FOOTER //
// ./app/src/models/user_model.js